
import React from 'react';
import { Button } from "@/components/ui/button";
import { Check, X, Trash2, Import } from "lucide-react";

type ManufacturerObj = {
  maker_id: number;
  manufacturer_id: number;
  name: string;
  market?: string;
  adObj?: any;
  atpObj?: any;
  masterObj?: any;
};

interface ManufacturerRowProps {
  manufacturer: ManufacturerObj;
  masterPresent: boolean;
  adPresent: boolean;
  atpPresent: boolean;
  onImport: (man: any) => void;
  onRemove: (makerId: number, market: string) => void;
  importSourceObj: any;
}

const ManufacturerRow: React.FC<ManufacturerRowProps> = ({
  manufacturer,
  masterPresent,
  adPresent,
  atpPresent,
  onImport,
  onRemove,
  importSourceObj,
}) => {
  return (
    <tr>
      <td>{manufacturer.name}</td>
      <td>
        {masterPresent ? <Check className="text-green-500 h-5 w-5" /> : <X className="text-red-500 h-5 w-5" />}
      </td>
      <td>
        {adPresent ? <Check className="text-green-500 h-5 w-5" /> : <X className="text-red-500 h-5 w-5" />}
      </td>
      <td>
        {atpPresent ? <Check className="text-green-500 h-5 w-5" /> : <X className="text-red-500 h-5 w-5" />}
      </td>
      <td>
        {masterPresent ? (
          <Button
            variant="destructive"
            size="sm"
            onClick={() => onRemove(manufacturer.maker_id, manufacturer.market!)}
          >
            <Trash2 className="w-4 h-4 mr-2" />
            Remove
          </Button>
        ) : (
          (adPresent || atpPresent) &&
          <Button
            variant="outline"
            size="sm"
            onClick={() => onImport(importSourceObj)}
          >
            <Import className="w-4 h-4 mr-2" />
            Import
          </Button>
        )}
      </td>
    </tr>
  );
};

export default ManufacturerRow;
